/**
 * Window type extension for Cypress detection
 */
type CypressWindow = Window & {
  Cypress?: unknown
}

/**
 * Detects if the current window is running in a Cypress test environment.
 *
 * This checks both:
 * - The navigator user agent for 'Cypress' (set by Cypress browser)
 * - The window.Cypress object (set by Cypress runtime)
 *
 * @returns true if running in Cypress, false otherwise
 */
export const isCypressWindow = (): boolean =>
  typeof window !== 'undefined' &&
  (navigator?.userAgent?.includes('Cypress') || !!(window as CypressWindow).Cypress)
